module.exports = __webpack_public_path__ + "img/downQR.0c55a28a.png";